var _polygon, _polygon2, _rect, _polyline, _polyline2, _polyline3, _polyline4, _path, _polyline5, _path2, _polyline6, _path3, _path4, _polyline7, _line, _line2, _polyline8, _g, _line3, _line4, _g2, _path5, _path6, _g3, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _g4, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomepurchaseGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#999999",
    points: "60.21,36.96 68.45,42.13 94.41,23.56 128.68,47.65 128.68,65.54 148.7,79.4 148.7,111.95 138.33,111.95 138.33,86.45 101,86.45 101,112.48 89.92,112.48 89.92,110.16 58.6,110.16 58.6,107.94 17.51,107.94 17.51,66.77"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#666666",
    points: "107.95,107.94 17.51,107.94 17.51,67.01 17.16,67.01 60.21,36.96 68.45,42.13 107.95,66.93   "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 86.45,
    fill: "#FFFFFF",
    width: 37.33,
    height: 24.51
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "#999999",
    points: "128.68,65.54 148.59,79.48 148.59,111.58 138.33,111.58 138.33,86.07 101,86.07 101,112.1 89.92,112.1 89.92,79.65 119.25,59 128.68,65.54"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#999999",
    points: "85.22,62.15 101,71.7 101,110.16 58.6,110.16 58.35,80.95 85.22,62.15"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFEA80",
    stroke: "#FFD500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "69.62,107.66 69.62,85.61 80.2,85.61 80.2,107.66"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "112.23,42.55 112.23,54.3 96.22,54.3 96.22,42.55 110.18,42.55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M69.68,110.23 c0,0-1.63,2.36-3.31,5.58c-4.69,9,34.63,12.31,34.63,12.31"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "68.89,58.44 68.89,69.11 60.24,69.11 60.24,56.19 68.89,56.19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M79.25,110.23c0,0-1.07,2.26-2.56,5.58c-1.51,3.37,26.01,5.17,26.01,5.17"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "42.1,84.93 48.47,84.93 48.47,100.34 27.12,100.34 27.12,84.93 31.74,84.93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M43.85,100.34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M31.74,100.34"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "50.75,58.44 50.75,69.11 42.1,69.11 42.1,56.19 50.75,56.19"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 42.1,
    y1: 84.93,
    x2: 42.1,
    y2: 100.34
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 104.23,
    y1: 54.3,
    x2: 104.23,
    y2: 45.05
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    points: "33.49,100.34 33.49,84.93 40.12,84.93  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1A1500",
    strokeWidth: 2,
    strokeLinejoin: "round",
    x1: 71.52,
    y1: 90.89,
    x2: 74.52,
    y2: 90.89
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1A1500",
    strokeWidth: 2,
    strokeLinejoin: "round",
    x1: 75.16,
    y1: 90.89,
    x2: 78.16,
    y2: 90.89
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFD500",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 68.72,
    y1: 85.45,
    x2: 80.95,
    y2: 85.45
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 138.33,
    y1: 110.98,
    x2: 101,
    y2: 110.98
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    x1: 105.15,
    y1: 94.21,
    x2: 117.15,
    y2: 94.21
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    x1: 122.18,
    y1: 94.21,
    x2: 134.18,
    y2: 94.21
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M101.31,112.48c0,0,0.68,6.2,1.38,8.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M137.78,111.73c0,0,7.94,10.33,10.31,13.08"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 58.6,107.94 17.51,107.94 17.51,68.9"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 128.68,
    y1: 47.65,
    x2: 128.68,
    y2: 65.54
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 60.21,
    y1: 36.96,
    x2: 68.45,
    y2: 42.13
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 12.92,
    y1: 69.97,
    x2: 60.21,
    y2: 36.96
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 68.45,
    y1: 42.13,
    x2: 107.95,
    y2: 66.93
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 85.22,
    y1: 62.15,
    x2: 101,
    y2: 71.7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 54.34,
    y1: 83.76,
    x2: 85.22,
    y2: 62.15
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 89.92,110.16 58.6,110.16 58.6,83.29"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 119.25,
    y1: 58.96,
    x2: 128.68,
    y2: 65.54
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 85.16,
    y1: 82.76,
    x2: 119.25,
    y2: 58.96
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 89.92,81.56 89.92,112.48 101,112.48 101,86.45 138.33,86.45 138.33,111.95 148.59,111.95 148.59,80.06"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 128.68,
    y1: 65.54,
    x2: 153.35,
    y2: 82.76
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 68.45,42.13 94.41,23.56 133.77,51.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    points: "67.31,110.16 67.31,107.94 82.66,107.94 82.66,110.16"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 29,
    y1: 17.34,
    x2: 112.43,
    y2: 17.34
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 88.43,
    y1: 19.44,
    x2: 38.5,
    y2: 19.44
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 47.15,
    y1: 21.53,
    x2: 61.74,
    y2: 21.53
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 8.02,
    y1: 29.68,
    x2: 32.03,
    y2: 29.68
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 67.45,
    y1: 31.77,
    x2: 17.52,
    y2: 31.77
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 26.16,
    y1: 33.86,
    x2: 40.76,
    y2: 33.86
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 66.46,
    y1: 15.25,
    x2: 74.48,
    y2: 15.25
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AAFF",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 92.36,
    y1: 13.16,
    x2: 102.22,
    y2: 13.16
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#666666",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 101.37,
    y1: 80.06,
    x2: 112.23,
    y2: 80.06
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#666666",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 105.24,
    y1: 77.97,
    x2: 115.11,
    y2: 77.97
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#666666",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 105.24,
    y1: 82.26,
    x2: 115.11,
    y2: 82.26
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#999999",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 20.59,
    y1: 71.65,
    x2: 31.46,
    y2: 71.65
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#999999",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 24.47,
    y1: 69.55,
    x2: 34.33,
    y2: 69.55
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#999999",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 24.47,
    y1: 73.85,
    x2: 34.33,
    y2: 73.85
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#666666",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 76.62,
    y1: 45,
    x2: 87.48,
    y2: 45
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#666666",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 80.49,
    y1: 42.9,
    x2: 90.36,
    y2: 42.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#666666",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 80.49,
    y1: 47.2,
    x2: 90.36,
    y2: 47.2
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M40.58,108.38c0.06-3.64,4.23-4.5,5.33-4.5c0.99,0,5.12,0,6.47,4.8c2.89,0.25,5.37,3.87,5.86,4.56c1.8,8.98-14.43,5.78-16.26,5.78c-1.83,0-2.81-1.13-2.81-6.1C39.16,109.42,39.65,108.57,40.58,108.38z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M47.27,119.5c-4.04,0-12.52,0.33-12.75-0.47c-4.2-0.05-5.19-3.13-5.19-4.06c0-0.85-0.25-3.88,5.29-5.05c0.28-2.48,1.77-4.52,4.77-4.52c3.95-0.59,6.24,0.53,7.22,2.29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M58.23,113.24c1.97,9.18-21.61,6.29-23.71,6.29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepurchaseGoal);
export default __webpack_public_path__ + "static/media/homepurchase-goal.391c690c.svg";
export { ForwardRef as ReactComponent };